import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";

interface PageName {
  plural: string;
  singular: string;
}

interface Props {
  count?: number;
  pageName?: PageName;
  pageNameChoice?: keyof PageName;
  templateType: "book" | "mural" | "print";
  translationBase: string;
}

const TranslationByType: FunctionComponent<Props> = ({
  count,
  pageName,
  pageNameChoice,
  templateType,
  translationBase,
}) => {
  const intl = useIntl();
  let translation;
  let trId: string;
  let trValues: { count?: number; pageName?: string } | undefined;

  if (pageName?.singular || pageName?.plural) {
    trId = `${translationBase}__generic`;

    if (count) {
      trValues = {
        count,
        pageName: count > 1 ? pageName.plural : pageName.singular,
      };
    } else if (pageNameChoice) {
      trValues = { pageName: pageName[pageNameChoice] };
    } else {
      trValues = { pageName: pageName.singular };
    }
  } else {
    if (count) {
      trValues = { count };
    }

    switch (templateType) {
      case "print":
        trId = `${translationBase}__print`;
        break;
      case "mural":
        trId = `${translationBase}__mural`;
        break;
      case "book":
        trId = `${translationBase}__book`;
        break;
      default: {
        const exhaustiveCheck: never = templateType;
        throw new Error(`Unsupported templateType ${exhaustiveCheck as string}`);
      }
    }
  }
  if (trValues) {
    translation = intl.formatMessage({ id: trId }, { ...trValues });
  } else {
    translation = intl.formatMessage({ id: trId });
  }

  return <>{translation}</>;
};

export default TranslationByType;
